import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { autoLoginGuard } from './core/guards/auto-login.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { MyinfoRedirectionComponent } from './myinfo-redirection/myinfo-redirection.component';
import { RemitComponent } from './remit/remit.component';
import { UiKitComponent } from './ui-kit/ui-kit.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [autoLoginGuard],
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'ui-kit',
    component: UiKitComponent
  },
  {
    path: 'remit',
    loadChildren: () => import('./remit/remit.module').then(m => m.RemitModule),
    canActivate: [authGuard]
  },
  { path: 'redirect', component: MyinfoRedirectionComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: '',
        loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule)
      },
      { path: '**', redirectTo: '/dashboard', pathMatch: 'full' }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
